import { RouteType } from "types/RouteType";
import LlmRoutingStore from "./LlmRoutingStore";

const llmRoutingRoute: RouteType[] = [
  {
    name: "LlmRouting",
    path: "/ai/routing",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Task Routing",
        enableRefreshButton: true,
        component: () => import("./LlmRouting.Header"),
      },
      body: {
        component: () => import("./LlmRouting.Body"),
        grayBackground: true,
      },
    },
    group: "AI",
    searchAliases: ["ai routing", "model routing"],
    // Task routing assigns the app-wide LLM tasks to configured providers —
    // admin-only, mirroring the AI → Providers page. The API enforces the admin
    // gate on writes (llm rbac hooks); this route is admin-only so the view is
    // hidden from non-admins.
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.llmRoutingStore as LlmRoutingStore;
      store?.load();
    },
  },
];

export default llmRoutingRoute;
